import { useContextStore } from '@/stores/context'

/**
 * `true` when the logged-in user's account belongs to the Brazil tenant.
 * Used to gate Brazil-specific UI (CPF / CNPJ / CEP fields, etc.).
 */
export function useIsBrazilTenant(): boolean {
  return useContextStore(
    (state) => state.userAccountContext?.tenantInformation.code === 'BRAZIL',
  )
}
